
import Request from '@/commons/request'
import Message from "@/components/message";
import storage from '@/commons/storage';
export default {
    data() {
        return {
            /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
            queryParam: {},
            /* 数据源 */
            desserts: [],
            /* table加载状态 */
            loading: false,
            /* 高级查询条件 */
            superQueryParams: "",
            page: {
                pageno: 1,
                limit: 10
            },
            pageData: {},

        }
    },
    created() {
        this.user = storage.get("_wit_acis_users");
    },
    methods: {
        loadPage() {
            if (!this.url.list) {
                Message.toast("请先设置url.list属性", { color: 'warning' });
                return
            }
            var params = this.getQueryParams();//查询条件
            this.loading = true;
            Request.postJson(this.url.list, params).then((res) => {
                if (res.meta.success || res.data) {
                    this.desserts = res.data.rows;
                    this.pageData = res.data;
                } 
                this.loading = false;
            })
        },
        getQueryParams() {
            // if (!this.queryParam.areaCode) {
            //     this.queryParam.areaCode = this.user.areacode;
            // }
            var codex = Object.assign({}, this.queryParam);
            var params = {};
            params.pageno = this.page.pageno;
            params.limit = this.page.limit;
            params.codex = codex;
            return params;
        },
        searchQuery() {
            this.page.pageno = 1;
            this.loadPage(1);
        },
        getListPage(page) {
            this.page.pageno = page.pageno
            this.page.limit = page.limit
            this.loadPage()
        },
     

        deleteItem: function (id,text) {
            if (!this.url.delete) {
                Message.toast('请设置url.delete属性!', { color: 'warning' });
                return
            }
            var that = this;
            Message.confirm(
                { title: '确认删除', text: text?text:'是否删除?' },
                (result) => {
                    result && Request.getForm(that.url.delete, { id: id }).then((res) => {
                        if (res.meta.success) {
                            Message.toast('删除成功', { color: 'success' });
                            that.loadPage();
                        } else {
                            Message.toast('删除失败', { color: 'warning' });
                        }
                    });
                }
            );

        },
        edit: function (record) {
            this.$refs.modalForm.edit(record);

        },
        add: function () {
            this.$refs.modalForm.add();
        },
        modalFormOk() {
            // 新增/修改 成功时，重载列表
            this.loadPage();
        },
        //导出
        expData() {
            this.overlay = true;
            var params = this.getQueryParams();//查询条件
            Request.exp(this.url.exp, params).then((res) => {
                if (res) {
                    const disposition = res.headers['content-disposition'];
                    const filename = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length));
                    let blob = new Blob([res.data], { type: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob);
                    } else {
                        const link = document.createElement('a');
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
                this.overlay = false;
            })
        },
    }

}